module.exports = __webpack_public_path__ + "img/brand-roll20.c6cbdeb5.svg";